// Financial Marketplace launch switch (credit-service platform API via the gateway).
// Global master + per-country kill-switch. Reading is platform-staff; flipping a
// switch is the KaziPeople superadmin (platform_owner) only — enforced server-side.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const BASE = `${API_V1}/credit/platform/marketplace-launch`;

export interface LaunchStatus {
  master: boolean;
  countries: Record<string, boolean>; // { TZ: false, KE: false, ... }
}

export const getLaunchStatus = () => axios.get<LaunchStatus>(BASE).then((r) => r.data);

// code = 'TZ' | 'KE' | 'UG' | 'RW' | '*' (global master)
export const setLaunch = (code: string, enabled: boolean) =>
  axios.put<LaunchStatus>(BASE, { code, enabled }).then((r) => r.data);
